export const table = {
  wrapper: {
    style: {
      borderRadius: "8px",
    },
  },

  header: {
    gap: "middle",
    justify: "space-between",
  },

  date: {
    picker: "year",
    allowClear: false,
  },

  addSemesterButton: {
    type: "primary",
  },


    actionsSection: {
      gap: "middle",
      wrap: "wrap",
      align: "center"
    },

    resetButton: {
      type: 'primary',
      style: {
        background: '#ff8399'
      }
    },

    saveButton: {
      type: "primary",
      style: {
        background: "#0eaf65",
      },
    },

    evaluateButton: {
      type: "primary"
    },
  };
  